import { API_HOST, getHttpDeleteOptions, getHttpGetOptions, getHttpPostOptions } from '../../utils/api-util';

const getEndpoint = () => `${API_HOST}/market`;

const getCreatePostEndpoint = () => `${getEndpoint()}/create/post`;
export const getCreatePostRequest = (post) => [getCreatePostEndpoint(), getHttpPostOptions(post)];

const getViewPostsEndpoint = () => `${getEndpoint()}/view/post`;
export const getViewPostsRequest = (filters) => [getViewPostsEndpoint(), getHttpPostOptions(filters)];

const getUpdatePostEndpoint = () => `${getEndpoint()}/update/post`;
export const getUpdatePostRequest = (post) => [getUpdatePostEndpoint(), getHttpPostOptions(post)];

const getDeletePostEndpoint = (postExternalReference) => `${getEndpoint()}/delete/post/${postExternalReference}`;
export const getDeletePostRequest = (postExternalReference) => [
  getDeletePostEndpoint(postExternalReference),
  getHttpDeleteOptions(),
];

const getPopulateMarketBuzzFilterEndpoint = () => `${getEndpoint()}/populate/filter`;
export const getPopulateMarketBuzzFilterRequest = () => [getPopulateMarketBuzzFilterEndpoint(), getHttpGetOptions()];

const getCreateReactionEndpoint = () => `${getEndpoint()}/create/reaction`;
export const getCreateReactionRequest = (reaction) => [getCreateReactionEndpoint(), getHttpPostOptions(reaction)];

const getViewReactionsEndpoint = (personExternalReference) =>
  `${getEndpoint()}/view/reaction/${personExternalReference}`;
export const getViewReactionsRequest = (personExternalReference) => [
  getViewReactionsEndpoint(personExternalReference),
  getHttpGetOptions(),
];

const getRetrieveChatEndpoint = (personExternalReference, postCreatorExternalReference) =>
  `${getEndpoint()}/retrieve/chat/${personExternalReference}/${postCreatorExternalReference}`;
export const getRetrieveChatRequest = (personExternalReference, postCreatorExternalReference) => [
  getRetrieveChatEndpoint(personExternalReference, postCreatorExternalReference),
  getHttpGetOptions(),
];

const getCreateCommentEndpoint = () => `${getEndpoint()}/create/comment`;
export const getCreateCommentRequest = (comment) => [getCreateCommentEndpoint(), getHttpPostOptions(comment)];

const getViewCommentsEndpoint = (postExternalReference, page, size) =>
  `${getEndpoint()}/view/comment/${postExternalReference}/${page}/${size}`;
export const getViewCommentsRequest = (postExternalReference, page, size) => [
  getViewCommentsEndpoint(postExternalReference, page, size),
  getHttpGetOptions(),
];

const getUpdateCommentEndpoint = () => `${getEndpoint()}/update/comment`;
export const getUpdateCommentRequest = (comment) => [getUpdateCommentEndpoint(), getHttpPostOptions(comment)];
